import { render, staticRenderFns } from "./AppLoggedAs.vue?vue&type=template&id=b4a2e8ba&scoped=true&"
import script from "./AppLoggedAs.vue?vue&type=script&lang=js&"
export * from "./AppLoggedAs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a2e8ba",
  null
  
)

export default component.exports